<template>
  <b-modal
    no-close-on-backdrop
    centered
    ok-only
    size="xl"
    ok-title="Fechar"
    ok-variant="danger"
    v-model="open"
    :title="`${fields.id} - Detalhes do lojista ${aboutCompany.title || ''}`"
    :busy="loading"
  >
    <b-row v-if="loading">
      <b-col cols="12" class="text-center">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12" class="text-center mb-4">
        <span class="font-weight-bold fs-18">Dados da  empresa</span>
      </b-col>
      <b-col cols="4">
        <Info
          label="Nome da loja no app"
          :value="aboutCompany.title || 'Sem nome definido'"
        />
      </b-col>

      <b-col cols="4">
        <Info
          label="Cnpj da loja"
          :value="dadosLojista.cnpj || 'Sem telefone definido'"
        />
      </b-col>

      <b-col cols="4">
        <Info
          label="Razão Social"
          :value="dadosLojista.razao_social || 'Sem telefone definido'"
        />
      </b-col>

      <b-col cols="4" class="mt-3">
        <Info
          label="Nome fantasia"
          :value="dadosLojista.nome_fantasia || 'Sem nome definido'"
        />
      </b-col>

      <b-col cols="4" class="mt-3">
        <Info
          label="Nome do responsável"
          :value="dadosLojista.nome_responsavel || 'Sem nome definido'"
        />
      </b-col>

      <b-col cols="4" class="mt-3">
        <Info
          label="Nome do solicitante"
          :value="dadosLojista.name || 'Sem nome definido'"
        />
      </b-col>

      <b-col cols="4" class="mt-3">
        <Info
          label="Telefone do solicitante"
          :value="dadosLojista.phone || 'Sem telefone definido'"
        />
      </b-col>

      <b-col cols="" class="mt-3">
        <Info
          label="Endereço"
          :value="endereco || 'Sem endereço definido'"
        />
      </b-col>

      <b-col cols="12">
        <hr />
      </b-col>

      <b-col cols="12" class="text-center">
        <span class="font-weight-bold fs-18">Customizações</span>
      </b-col>

      <b-col cols="12" class="my-3">
        <b-row>
          <b-col cols="6" class="mb-3">
            <Info label="Logo" :value="aboutCompany.logo ? '' : 'Sem logo'" />
            <div class="text-center" v-if="aboutCompany.logo">
              <b-img
                fluid
                :src="getImagesAddressApp + aboutCompany.logo"
                class="formatImgLogo"
              ></b-img>

              <div
                v-if="!downloading"
                class="btn btn-success col-12 pointer mt-1"
                @click="downloadImage(getImagesAddressApp + aboutCompany.logo, aboutCompany.logo)"
              >
                <i class="fas fa-download mr-3"></i>
                Download Logo
              </div>
              <b-spinner v-else small></b-spinner>
            </div>
          </b-col>

          <b-col cols="6" class="mb-3">
            <Info label="Ícone" :value="aboutCompany.icon ? '' : 'Sem ícone'" />
            <div class="text-center mt-4" v-if="aboutCompany.icon">
              <b-img fluid :src="getImagesAddressApp + aboutCompany.icon" class="formatImgLogo"></b-img>
              <div
                v-if="!downloading"
                class="btn btn-success col-12 pointer mt-1"
                @click="downloadImage(getImagesAddressApp + aboutCompany.icon, aboutCompany.icon)"
              >
                <i class="fas fa-download mr-3"></i>
                Download Ícone
              </div>
              <b-spinner v-else small></b-spinner>
            </div>
          </b-col>

          <b-col class="mt-2">
            <Info
              label="Cor de fundo"
              :value="customization.backgroundColor ? '' : 'Sem cor definida'"
            />
            <chrome-picker
              v-if="!!customization.backgroundColor"
              v-model="customization.backgroundColor"
            />
          </b-col>

          <b-col class="mt-2">
            <Info
              label="Cor da fonte"
              :value="customization.fontColor ? '' : 'Sem cor definida'"
            />
            <chrome-picker
              v-if="!!customization.fontColor"
              v-model="customization.fontColor"
            />
          </b-col>

          <b-col class="mt-2">
            <Info
              label="Cor dos ícones"
              :value="customization.iconColor ? '' : 'Sem cor definida'"
            />
            <chrome-picker
              v-if="!!customization.iconColor"
              v-model="customization.iconColor"
            />
          </b-col>

          <b-col class="mt-2">
            <Info
              label="Cor do menu"
              :value="customization.menuHeaderColor ? '' : 'Sem cor definida'"
            />
            <chrome-picker
              v-if="!!customization.menuHeaderColor"
              v-model="customization.menuHeaderColor"
            />
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12">
        <hr />
      </b-col>

      <b-col cols="12" class="text-center">
        <span class="font-weight-bold fs-18">Aplicativo / Site</span>
      </b-col>

      <div class="row col mt-3">
        <div class="col-md-4 form-group" v-if="customization.linkAndroid != '' && customization.linkAndroid != null">
          <label class="font-weight-bold">Link Android:</label><br />
          <div class="input-group mb-2 mr-sm-2" @click="copyToClipboard(customization.linkAndroid)">
            <input type="text" class="form-control" v-model="customization.linkAndroid" disabled>
            <div class="input-group-prepend">
              <div class="input-group-text" style="cursor:pointer;border: 1px solid #28a745;">
                <i class="far fa-copy" style="color:#28a745;"></i>
              </div>
            </div>
          </div>
          <div class="text-center mt-4">
            <span class="d-none">
              <qrcode-vue
                class="mt-2"
                :value="customization.linkAndroid"
                size=500
                level="H"
                id="qrCodeCanvasAndroid"
              />
            </span>
            <qrcode-vue
              class="mt-2"
              :value="customization.linkAndroid"
              size=120
              level="H"
              id="qrCodeCanvasAndroid"
            />
            <button 
              @click="downloadQrCode('qrCodeCanvasAndroid', 'qrcode_android.png')" 
              size="sm" 
              class="btn btn-outline-success btn-sm"
            >
              <i class="fas fa-download mr-2"></i>
              Baixar qr code
            </button>
          </div>
        </div>

        <div class="col-md-4 form-group" v-if="customization.linkApple != '' && customization.linkApple != null">
          <label class="font-weight-bold">Link Apple:</label>
          <div class="input-group mb-2 mr-sm-2" @click="copyToClipboard(customization.linkApple)">
            <input type="text" class="form-control" v-model="customization.linkApple" disabled>
            <div class="input-group-prepend">
              <div class="input-group-text" style="cursor:pointer;border: 1px solid #28a745;">
                <i class="far fa-copy" style="color:#28a745;"></i>
              </div>
            </div>
          </div>
          <div class="text-center mt-4">
            <span class="d-none">
              <qrcode-vue
                class="mt-2"
                :value="customization.linkApple"
                size=500
                level="H"
                id="qrCodeCanvasApple"
              />
            </span>
            <qrcode-vue 
              class="mt-2"
              :value="customization.linkApple" 
              size=120 
              level="H" 
            />
            <button 
              @click="downloadQrCode('qrCodeCanvasApple', 'qrcode_apple.png')" 
              size="sm" 
              class="btn btn-outline-success btn-sm"
            >
              <i class="fas fa-download mr-2"></i>
              Baixar qr code
            </button>
          </div>
        </div>

        <div class="col-md-4 form-group" v-if="customization.domain != '' && customization.domain != null">
          <label class="font-weight-bold">Site:</label>
          <div class="input-group mb-2 mr-sm-2" @click="copyToClipboard(customization.domain)">
            <input type="text" class="form-control" v-model="customization.domain" disabled>
            <div class="input-group-prepend">
              <div class="input-group-text" style="cursor:pointer;border: 1px solid #28a745;">
                <i class="far fa-copy" style="color:#28a745;"></i>
              </div>
            </div>
          </div>
          <div class="text-center mt-4">
            <span class="d-none">
              <qrcode-vue
                class="mt-2"
                :value="customization.domain"
                size=500
                level="H"
                id="qrCodeSite"
              />
            </span>
            <qrcode-vue 
              class="mt-2"
              :value="customization.domain" 
              size=120 
              level="H" 
            />
            <button 
              @click="downloadQrCode('qrCodeSite', 'qrcode_site.png')" 
              size="sm" 
              class="btn btn-outline-success btn-sm"
            >
              <i class="fas fa-download mr-2"></i>
              Baixar qr code
            </button>
          </div>
        </div>
      </div>

      <b-col cols="12">
        <hr />
      </b-col>

      <b-col cols="12" class="text-center">
        <span class="font-weight-bold fs-18">Frete</span>
      </b-col>
      <b-col cols="12" class="my-3">
        <b-row>
          <b-col class="mt-2">
            <Info
              label="Valor do frete fixo"
              :value="formatNumber(freights.fixedFreight)"
            />
          </b-col>
          <b-col class="mt-2">
            <Info
              label="Valor para ter frete grátis"
              :value="formatNumber(freights.freightValueToFree)"
            />
          </b-col>
          <b-col class="mt-2">
            <Info
              label="Disponibiliza retirada em loja?"
              :value="freights.pickupInStore ? 'Sim' : 'Não'"
            />
          </b-col>
          <b-col class="mt-2">
            <Info label="Raio de atuação" :value="`${freights.radius}km`" />
          </b-col>
          <b-col class="mt-2" cols="12">
            <Info
              label="Endereço"
              :value="freights.address || 'Sem endereço cadastrado no frete'"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12">
        <hr />
      </b-col>
      <b-col cols="12">
        <Info label="Resumo" :value="aboutCompany.resume || 'Sem resumo'" />
      </b-col>
      <b-col cols="12" class="mt-3">
        <Info label="Assunto" :value="aboutCompany.subject || 'Sem assunto'" />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { Chrome } from 'vue-color';
import { mapActions, mapState, mapGetters } from 'vuex';
import {
  formatNumber,
  downloadFile,
  downloadFileFromBase64,
} from '@/utils/index.js';

import makeToast from '@/mixins/makeToast';
import QrcodeVue from 'qrcode.vue';
import Info from '../Inputs/Info.vue';

export default {
  name: 'ShopkeeperDetailsWithApp',
  mixins: [makeToast],
  data() {
    return {
      loading: false,
      downloading: false,
      open: false,
      dadosLojista: {},
      endereco: '',
      socialMedias: {},
      aboutCompany: {},
      customization: {},
      banners: [],
      freights: {},
      fields: this.defaultShopkeeper(),
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddressApp']),
  },
  methods: {
    formatNumber,
    downloadFile,
    ...mapActions('files', ['getFileBase64']),
    ...mapActions('shopkeeper', [
      'getSocialMedias',
      'getAboutCompany',
      'getCustomization',
      'getBanner',
      'getFreight',
    ]),
    copyToClipboard(value) {
      navigator.clipboard.writeText(value);
      this.makeToast('Sucesso!', 'Link copiado com sucesso!', 'success');
    },
    downloadQrCode(elementId, fileName){
      var qrCodeCanvas = document.getElementById(elementId).getElementsByTagName('canvas');
      var dataUrl = qrCodeCanvas[0].toDataURL();

      let xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function () {
        let a = document.createElement('a');
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
      };

      xhr.open('GET', dataUrl);
      xhr.send();
    },
    toggleOpen({ shopkeeperId = 0, dadosLojista = ''}) {
      this.clean();

      this.open = !this.open;
      this.fields.id = shopkeeperId;

      this.dadosLojista = dadosLojista,
      this.endereco  = this.dadosLojista.endereco + ', ' + this.dadosLojista.bairro +' - '+ this.dadosLojista.nome_cidade + ' / ' + this.dadosLojista.nome_estado
      this.get();
    },
    async get() {
      if (this.loading || !this.fields.id) return;

      this.loading = true;

      this.getSocialMedias(this.fields.id)
        .then((socialMediasResponse) => {
          this.socialMedias = socialMediasResponse.data.data || {};
        })
        .catch();
      this.getAboutCompany(this.fields.id)
        .then((aboutCompanyResponse) => {
          this.aboutCompany = aboutCompanyResponse.data.data || {};
        })
        .catch();
      this.getCustomization(this.fields.id)
        .then((customizationResponse) => {
          this.customization = customizationResponse.data.data || {};
        })
        .catch();
      this.getBanner(this.fields.id)
        .then((bannersResponse) => {
          this.banners = bannersResponse.data.data || {};
        })
        .catch();
      this.getFreight(this.fields.id)
        .then((freightsResponse) => {
          this.freights = freightsResponse.data.data || {};
        })
        .catch()
        .finally(() => {
          this.loading = false;
        });
    },
    clean() {
      this.fields = this.defaultShopkeeper();
      this.socialMedias = {};
      this.aboutCompany = {};
      this.customization = {};
      this.banners = [];
      this.freights = {};
    },
    async downloadImage(url, fileName) {
      this.downloading = true;

      const response = await this.getFileBase64({ url });

      this.downloading = false;

      if (!response || !response.data || !response.data.base64) return;

      const { base64 } = response.data || {};

      const extension = (fileName || '').split('.')[1];

      downloadFileFromBase64({
        base64,
        fileName,
        extension,
        mimeType: `image/${extension}`,
        addDataUriOnBase64: true,
      });
    },
    defaultShopkeeper() {
      return {
        id: '',
      };
    },
  },
  components: {
    Info,
    QrcodeVue,
    'chrome-picker': Chrome,
  },
};
</script>

<style scoped>
.formatImgLogo {
  width: 200px !important;
  height: auto;
}
</style>
